import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 12px;
    height: 12px;
  }
`;

export const IconBiggerWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 16px;
    height: 16px;
  }
`;
